<div>
  <nav class="navbar navbar-expand-lg navbar-Create">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active-link" routerLink="articles">Articles</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active-link" routerLink="menu-items">Menu Items</a>
        </li>
      </ul>
    </div>
  </nav>
  <router-outlet></router-outlet>
</div>
